import { types, SnapshotOut } from 'mobx-state-tree';
import { marketingActionsDtos, ProgressStateModel, ProgressStateModelForStore } from 'eTip--common';
import { observable } from 'mobx';

export enum MarketingActionType {
    Unknown = 0,
    Points = 1
}

export const MarketingActionPlayer = types.model({
    sequence: types.number,
    name: types.string,
    value: types.string,
    isCurrent: types.boolean
})

export const MarketingActionStore = types
    .model({
        state: types.optional(ProgressStateModelForStore, ProgressStateModel.NotInitialized),
        isAvailable: types.optional(types.boolean, false),
        actionName: types.maybeNull(types.string),
        actionDescription: types.maybeNull(types.string),
        players: types.maybeNull(types.array(MarketingActionPlayer)),
        showUnrolled: types.maybeNull(types.boolean)
    }).actions(self => {

        const getTextFromValue = (value: number, _type: MarketingActionType) => {
            return value.toString() + " b";
        }

        const setData = (response: marketingActionsDtos.MarketingActionsResponse, currentPlayerId: number): void => {
            if (response) {
                self.isAvailable = true;
                self.actionName = response.Action.Name;
                self.actionDescription = response.Action.Description;
                self.players = observable([]);
                response.ActionPlayerValues.forEach(item => {
                    self.players.push(MarketingActionPlayer.create(<SnapshotOut<typeof MarketingActionPlayer>>{
                        sequence: item.Sequence,
                        name: item.PlayerName,
                        value: getTextFromValue(item.Value, response.Action.Type),
                        isCurrent: item.PlayerId === currentPlayerId
                    }));
                });
                self.showUnrolled = response.Action.ShowUnrolled;
            } else {
                self.isAvailable = false;
                self.actionName = "";
                self.actionDescription = "";
                self.players = observable([]);
                self.showUnrolled = false;
            }
            self.state = ProgressStateModel.Success;
        }

        return {
            setData
        }

    });
